import axios from "axios";
import store from "@/store";

const instance = axios.create({
    baseURL:process.env.NODE_ENV === "production" ? "https://hunan.tianditu.gov.cn/api" : '/',
    timeout:5000
})

// 请求拦截器
instance.interceptors.request.use(config => {
    return config
},error => {
    return Promise.reject(error)
})

// 响应拦截器
instance.interceptors.response.use(response => {
    if(response.data.code === 200){
        return response.data
    }else{
        if(response.data.code == 401){
            // 重新调用获取ai的token接口
            store.dispatch('globalParams/getAITokenData')
        }else {
            return Promise.reject(response.data.msg)
        }
    }
},error => {
    return Promise.reject(error)
})

export default instance